import React from "react";
import { Row, Col } from "antd";
import { Link } from "react-router-dom";
import "./style.css";
import { notification } from "antd";
import { WarningTwoTone } from "@ant-design/icons";
import Faqs from "../../../Images/cards/faqs.jpg";
import ItWorld from "../../../Images/cards/itWorld.jpg";
import Learning from "../../../Images/cards/learning.jpg";
import Progress from "../../../Images/cards/progress.jpg";

export default class PortalCards extends React.Component {
  notActiveNotification = () => {
    let placement = "bottomRight";
    const key = `open${Date.now()}`;
    notification.open({
      duration: 5,
      message: "Attention Champion!",
      description: (
        <div id="loading">
          <h3>This feature is under development.</h3>
          <p>Please visit again later, Thanks.</p>
        </div>
      ),
      placement,
      icon: <WarningTwoTone twoToneColor="#BF2F2F" />,
      key,
    });
  };

  render() {
    return (
      <div className="portalCardContainer">
        <Row gutter={[48, 48]} className="portalCardRow tc">
          <Col span={6} className="animate__animated animate__fadeInRightBig">
            <Link to="/courses">
              <div className="grow homeCard">
                <div className="image">
                  <img alt="example" className="homeCardImg" src={Learning} />
                </div>
                <div className="details">
                  <div className="center">
                    <h1>
                      Learning Plan
                      <br />
                      <span>Begin your training</span>
                    </h1>
                  </div>
                </div>
              </div>
            </Link>
          </Col>
          <Col span={6} className="animate__animated animate__fadeInUpBig">
            <Link to="/itworld">
              <div className="grow homeCard">
                <div className="image">
                  <img alt="example" className="homeCardImg" src={ItWorld} />
                </div>
                <div className="details">
                  <div className="center">
                    <h1>
                      IT World
                      <br />
                      <span>All IT realted videos are available here</span>
                    </h1>
                  </div>
                </div>
              </div>
            </Link>
          </Col>
          <Col span={6} className="animate__animated animate__fadeInUpBig">
            <Link
              // to="/myLearning"
              onClick={this.notActiveNotification}
            >
              <div className="grow homeCard">
                <div className="image">
                  <img alt="example" className="homeCardImg" src={Progress} />
                </div>
                <div className="details">
                  <div className="center">
                    <h1>
                      Progress
                      <br />
                      <span>View your in-depth progress so far</span>
                    </h1>
                  </div>
                </div>
              </div>
            </Link>
          </Col>{" "}
          <Col span={6} className="animate__animated animate__fadeInLeftBig">
            <Link to="/faqs">
              <div className="grow homeCard">
                <div className="image">
                  <img alt="example" className="homeCardImg" src={Faqs} />
                </div>
                <div className="details">
                  <div className="center">
                    <h1>
                      FAQs
                      <br />
                      <span>You have a question ? </span>
                    </h1>
                  </div>
                </div>
              </div>
            </Link>
          </Col>
        </Row>
      </div>
    );
  }
}
